import { coreFetch } from '@libs/core';

// TODO: rename coreFetch under '@libs/core' to typedFetch and update imports.
export const typedFetch = coreFetch;
